import { compactSmall } from "../../helpers/formatters"
import { css, cx } from "@emotion/css"
import { Box } from "@material-ui/core"
import { useI18n } from "providers/I18n"
import { stylesWidgetStats } from "../../styles"

export function WidgetEconomicalData({
  data,
  type,
}: {
  data: { growth?: number; currency?: string; value?: number }
  type: string
}) {
  const { t } = useI18n()

  return (
    <Box display="flex" flexDirection="column">
      <span
        className={cx(
          "HeadingH5bBold",
          styles.text,
          stylesWidgetStats.topElement,
        )}
      >
        {type === "revenue" ? t("revenue.revenue") : t("revenue.billings")}
      </span>
      <span
        className={cx(
          "HeadingH1Bold",
          styles.smallerHeader,
          styles.text,
          stylesWidgetStats.topElement,
        )}
      >
        {data?.value ? `${data?.currency}${compactSmall(data.value)}` : "N/A"}
      </span>
      <span
        className={cx(
          "BodyBody1Regular",
          styles.lighter,
          styles.text,
          stylesWidgetStats.topElement,
        )}
      >
        {data.growth ? `${compactSmall(data?.growth)}%` : "N/A"}{" "}
        {type === "revenue"
          ? t("revenue.yoyrevenuegrowth")
          : t("revenue.yoybillingrowth")}
      </span>
    </Box>
  )
}

const styles = {
  text: css`
    text-align: left;
    color: var(--white);
  `,
  smallerHeader: css`
    font-size: 48px;
  `,
  lighter: css`
    opacity: 50%;
  `,
}
